var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.showLoader)?_c('Loader'):_vm._e(),(!_vm.isBrowserCompatible)?_c('CheckBrowser'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }